import { createAction } from 'redux-actions';

import { setFlashMessage } from 'app/features/flashMessage/actions';
import { AUTHENTICATION_FAILED } from 'app/features/authentication/actions/actionTypes';

const authenticationFailed = createAction(AUTHENTICATION_FAILED);

const createFlashMessage = messageId =>
  setFlashMessage({
    messageId,
    statusType: 'error',
  });

const authErrorHandler =
  ({ dispatch, map, defaultMessage }) =>
  ({ code, message }) => {
    dispatch(authenticationFailed());

    if (code === 'internal_server_error') dispatch(createFlashMessage(message));
    else dispatch(createFlashMessage(map[code] || defaultMessage));
  };

export { authErrorHandler, authenticationFailed };
